import { useState } from "react"
import Tabs from "aldoo-ra/Tabs"

export default function GroupRenderTabs({
  namedGroups,
  ungroupedGroup,
  renderGroupFields,
  fieldSearchData,
  renderSearchResults,
}) {
  const [activeTab, setActiveTab] = useState(namedGroups[0]?.id ?? "__ungrouped__")

  if (fieldSearchData?.hasActiveSearch) {
    return renderSearchResults()
  }

  // No named groups — render fields flat without tab chrome
  if (!namedGroups.length) {
    return <div>{renderGroupFields(ungroupedGroup)}</div>
  }

  const tabs = namedGroups.map((g) => ({ value: g.id, label: g.label }))

  // Add a General tab for ungrouped fields if any exist
  const hasUngrouped = ungroupedGroup._hasContent
  if (hasUngrouped) {
    tabs.push({ value: "__ungrouped__", label: "General" })
  }

  const activeGroup =
    activeTab === "__ungrouped__"
      ? ungroupedGroup
      : namedGroups.find((g) => g.id === activeTab)

  return (
    <div>
      <Tabs
        tabs={tabs}
        value={activeTab}
        onChange={setActiveTab}
        variant="admin"
        className="mb-4"
      />
      <div className="min-h-[200px]">
        {activeGroup && renderGroupFields(activeGroup)}
      </div>
    </div>
  )
}
